import React from 'react';
import UserForm from './form';

const UserNew = () => {
    return <UserForm />;
};

export default UserNew;
